/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AssetCartDTO } from '../models/AssetCartDTO';
import type { AssetCartDTOODataListResponse } from '../models/AssetCartDTOODataListResponse';
import type { AssetCartEditDTO } from '../models/AssetCartEditDTO';
import type { AssetCartItemDTO } from '../models/AssetCartItemDTO';
import type { AssetCartItemEditDTO } from '../models/AssetCartItemEditDTO';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AssetCartService {

    /**
     * @param top The max number of records.
     * @param skip The number of records to skip.
     * @param filter A function that must evaluate to true for a record to be returned.
     * @param select Specifies a subset of properties to return. Use a comma separated list.
     * @param orderby Determines what values are used to order a collection of records.
     * @param expand Use to add related query data.
     * @param count Include the overall count
     * @returns AssetCartDTOODataListResponse Success
     * @throws ApiError
     */
    public static getAssetCart(
top?: string,
skip?: string,
filter?: string,
select?: string,
orderby?: string,
expand?: string,
count?: string,
): CancelablePromise<AssetCartDTOODataListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/AssetCart',
            query: {
                '$top': top,
                '$skip': skip,
                '$filter': filter,
                '$select': select,
                '$orderby': orderby,
                '$expand': expand,
                '$count': count,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns AssetCartDTO Success
     * @throws ApiError
     */
    public static postAssetCart(
requestBody?: AssetCartEditDTO,
): CancelablePromise<AssetCartDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/AssetCart',
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    }

    /**
     * @returns binary Success
     * @throws ApiError
     */
    public static getAssetCartPowerpoint(): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/AssetCart/powerpoint',
        });
    }

    /**
     * @param key 
     * @param requestBody 
     * @returns AssetCartDTO Success
     * @throws ApiError
     */
    public static putAssetCart(
key: number,
requestBody?: AssetCartEditDTO,
): CancelablePromise<AssetCartDTO> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/AssetCart/{key}',
            path: {
                'key': key,
            },
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    }

    /**
     * @param key 
     * @returns any Success
     * @throws ApiError
     */
    public static deleteAssetCart(
key: number,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/AssetCart/{key}',
            path: {
                'key': key,
            },
        });
    }

    /**
     * @param key 
     * @param requestBody 
     * @returns AssetCartItemDTO Success
     * @throws ApiError
     */
    public static postAssetCartItems(
key: number,
requestBody?: AssetCartItemEditDTO,
): CancelablePromise<AssetCartItemDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/AssetCart/{key}/items',
            path: {
                'key': key,
            },
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    }

    /**
     * @param key 
     * @param id 
     * @returns any Success
     * @throws ApiError
     */
    public static deleteAssetCartItems(
key: number,
id: number,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/AssetCart/{key}/items/{id}',
            path: {
                'key': key,
                'id': id,
            },
        });
    }

}
